/*
  <bp-tabs>: WAI-ARIA tabs for sections/bp-product-tabs. Without JS the tablist stays hidden
  and every panel shows in order with its own title (progressive enhancement).
  Keys: Left/Right move between tabs, Home/End jump; activation follows focus.
*/
class BpTabs extends HTMLElement {
  connectedCallback() {
    if (this.dataset.ready) return; // idempotent across section re-renders
    this.list = this.querySelector('[role="tablist"]');
    this.tabs = [...this.querySelectorAll('[role="tab"]')];
    this.panels = this.tabs.map((t) => this.querySelector('#' + CSS.escape(t.getAttribute('aria-controls'))));
    if (!this.list || this.tabs.length < 2 || this.panels.some((p) => !p)) return; // one panel: nothing to switch
    this.abort = new AbortController();
    const { signal } = this.abort;
    this.list.hidden = false;
    this.dataset.ready = '';
    this.tabs.forEach((tab, i) => {
      tab.addEventListener('click', () => this.select(i), { signal });
      tab.addEventListener('keydown', (e) => this.onKey(e, i), { signal });
    });
    this.select(0, false);
  }

  disconnectedCallback() {
    this.abort?.abort();
  }

  onKey(event, i) {
    const last = this.tabs.length - 1;
    const next = { ArrowRight: i === last ? 0 : i + 1, ArrowLeft: i === 0 ? last : i - 1, Home: 0, End: last }[event.key];
    if (next === undefined) return;
    event.preventDefault();
    this.select(next);
  }

  select(index, focus = true) {
    this.tabs.forEach((tab, i) => {
      const on = i === index;
      tab.setAttribute('aria-selected', String(on));
      tab.tabIndex = on ? 0 : -1;
      this.panels[i].hidden = !on;
      this.panels[i].tabIndex = 0;
    });
    if (focus) this.tabs[index].focus();
  }
}

if (!customElements.get('bp-tabs')) customElements.define('bp-tabs', BpTabs);
